import React from 'react'
import Header from '../component/Common/Header'
import Banner from '../component/Common/Banner'
import AboutComponent from '../component/About'
import { useTranslation } from 'react-i18next';
const About = () => {
    const { t, i18n } = useTranslation();
    return (
        <>
         
            <Banner title={t("about")} />
            <AboutComponent />
          
        </>
    )
}

export default About